import { Flex } from "antd";
import { Icon } from '@synergy/icons';
import { Text } from "./Text";

export const NoData = () => {

    return(
        <Flex gap={10} align="center" justify="center" vertical="true" className="full-height">
            <Icon iconsize='xl' icon='Clipboard' color="coolgray-10"/>
            <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight="medium">No data</Text>
        </Flex>
    )
}